export function commonSymptomColumns() {
	var windowWidth = $(window).width();
	var commonSymptomBlocks = $('.common_symptoms');
	$(commonSymptomBlocks).each(function() {
		var thisEl = $(this);
		var numCols = $(thisEl).find('.symptoms_list li').length;
		if(numCols > 3) {
			$(thisEl).find('.symptoms_list ul').addClass('two-col');
		}
	});
}